import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const NavbarLink = ({ text, url, bold = false, handleMenuToggle, isMobile, alignRight }) => {
  let cleanedUrl = `${url}`;

  switch (url) {
    case 'BuscadorInsumos':
      cleanedUrl = '/buscadorinsumos';
      break;
    case 'Ofertas':
      cleanedUrl = '/ofertas';
      break;
    case 'Novedades':
      cleanedUrl = '/Novedades';
      break;
    default:
      break;
  }

  return (
    <li
      data-toggle={isMobile ? 'collapse' : null}
      data-target="#navsitemenu"
      onClick={(e) => handleMenuToggle(e)}
    >
      <Link to={`${cleanedUrl}`} style={{ textAlign: alignRight ? 'right' : '' }}>{bold ? <strong>{text}</strong> : <span>{text}</span>}</Link>
    </li>
  );
};

export default NavbarLink;
